import { Injectable, InjectionToken, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { RestResourceService } from './rest-resource.service';
import { RestFrameworkService } from './rest-framework.service';
import { RestInterpolatorService } from './rest-interpolator.service';
import { RestJsonCodecService } from './rest-json-codec.service';

export interface RestParameterDescriptor {
  name: string;
  required?: boolean;
  type?: unknown;
  description?: string;
}

export interface RestResourceDescriptor {
  href: string;
  requestParameters: Array<RestParameterDescriptor>;
  pathVariables: Array<RestParameterDescriptor>;
  methods: Array<string>;
}

export interface RestResourceConfiguration {
  [key: string]: RestResourceDescriptor;
}

export interface RestConfiguration {
  readonly baseUrl: string;
  readonly resourceConfiguration: RestResourceConfiguration | unknown;
}

export const REST_CONFIGURATION = new InjectionToken<RestConfiguration>('restConfiguration');

@Injectable({
  providedIn: 'root'
})
export class RestService {

  private readonly baseUrl: string;
  private readonly resourceConfiguration: RestResourceConfiguration;

  constructor(@Inject(HttpClient) protected httpClient: HttpClient,
              @Inject(RestFrameworkService) protected restFrameworkService: RestFrameworkService,
              @Inject(RestInterpolatorService) protected restInterpolatorService: RestInterpolatorService,
              @Inject(RestJsonCodecService) protected restJsonCodecService: RestJsonCodecService,
              @Inject(REST_CONFIGURATION) configuration?: RestConfiguration) {
    this.baseUrl = configuration.baseUrl;
    this.resourceConfiguration = configuration.resourceConfiguration as RestResourceConfiguration;
  }

  getResource(resourceId: string): RestResourceService {
    return new RestResourceService(
      this.httpClient,
      this.restFrameworkService,
      this.restInterpolatorService,
      this.restJsonCodecService,
      {
        id: resourceId,
        baseUrl: this.baseUrl,
        descriptor: this.getResourceDescriptor(resourceId)
      }
    );
  }

  private getResourceDescriptor(resourceId: string): RestResourceDescriptor {
    let value = resourceId.split('.')
      .reduce((resourceValue: unknown, part: string): unknown => resourceValue && resourceValue[part], this.resourceConfiguration);
    if (value === undefined) {
      value = this.resourceConfiguration[resourceId];
    }
    return value as RestResourceDescriptor;
  }

}
